const FreelancerActiveStatusEnum = {
  ActiveEngaged: 'Active-Engaged',
  InactiveOffboarded: 'Inactive-Offboarded',
  InactiveNotEngaged: 'Inactive-NotEngaged',
};

export default FreelancerActiveStatusEnum;
